export default {
  translation: {
    regionPicker: {
      chooseArea: 'Kies uw gebied'
    },
    configurator: {
      configureNow: 'Configureer mijn handgreep !',
      chooseFrameColor: 'Kies hieronder uw framekleur',
      chooseHandle: 'Kies hieronder de gewenste handgreep',
      createYourOwnButton: 'Maak uw eigen ontwerp',
      createYourOwn: 'Upload uw ontwerp',
      sendConfig: 'Bewaar uw ontwerp',
      colorType: {
        ral: 'Gelakt',
        anodized: 'Geanodiseerd',
        decor: 'Decoratief',
        custom: 'Gepersonnaliseerd'
      },
      color: {
        black: 'Zwart',
        white: 'Wit'
      },
      form: {
        myConfig: 'Bewaar uw gepersonaliseerde handgreep',
        send: 'Verstuur!',
        success: 'Uw design is succesvol verstuurd per e-mail!',
        error: 'Er is een fout opgetreden tijdens het verzenden van de e-mail!',
        model: 'Handgreep model',
        color: 'Kleur',
        ornament: 'Decor',
        ornament_color: 'Kleuren decor',
        custom: 'Gepersonaliseerd decor'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/i18n/nl.js